<template>
  <div class="main-doctor">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <h1 class="title-pages">RESIDENTES - CADASTRAR SINAIS VITAIS</h1>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-2">
          <div class="text-center">
            <b>SELECIONAR TODOS OS RESIDENTES?</b>
            <b-form-group label="">
              <b-form-radio-group v-model="selectAll">
                <b-form-radio :value="true">SIM</b-form-radio>
                <b-form-radio :value="false">NÃO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="row">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="col-md-4 pt-0 pb-0"
            >
              <b-form-checkbox
                :value="resident.id"
                :checked="
                  resident_ids.find((resident_id) => resident_id == resident.id)
                "
                @change="handleChangeCheckbox($event, resident.id)"
                size="lg"
              >
                <div class="d-flex align-items-center">
                  <img
                    class="photo-url mr-2"
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                  />
                  <p class="m-0 text-twelve">
                    {{ resident.name }}
                  </p>
                </div>
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="mt-2 v-clean p-2">
            <Create
                :rest_home_id="rest_home_id"
                :resident_id="null"
                :user_id="user.id"
                :type="type"
                :open="true"
                :resident_ids="resident_ids"
                :multiplosResidents="true"
                v-on:popup="handlePopup"
                v-on:created="paginate"
            />
        </div>
        <div class="mt-2">
          <ErrorsMessages :errors="errors" />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar.vue";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired.vue";

import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

import Create from "../templates/Care/NursingCaregiver/Create/Single/VitalSigns";

import api from "../services/api";

import permission from "../lib/permission";

import { userData } from "../lib/functions";

export default {
  name: "ResidentsVitalSigns",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Create,
  },

  data() {
    return {
      selectAll: false,

      rest_home_id: "",
      type: "CUIDADOR_ENFERMAGEM",
      user: {},

      residents: [],
      resident_ids: [],

      errors: [],
      loading: false,
    };
  },

  watch: {
    selectAll() {
      if (this.selectAll) {
        this.resident_ids = this.residents.map(({ id }) => id);
      } else {
        this.resident_ids = [];
      }
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handlePopup() {},
    paginate() {
        this.resident_ids = [];
    },

    retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;

      this.user = user;

      this.getResidents();
    },

    handleChangeCheckbox(checked, resident_id) {
      let { resident_ids } = this;
      if (checked) {
        let find = resident_ids.find((id) => id == resident_id);
        if (!find) {
          resident_ids.push(resident_id);
        }
      } else {
        resident_ids.map((id, key) => {
          if (id == resident_id) {
            resident_ids.splice(key, 1);
          }
        });
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          for (let resident of residents) {
            resident.checked = true;
          }

          this.resident_ids = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.main-doctor .photo-url {
  width: 25px;
  height: 25px;
  object-fit: cover !important;
  border-radius: 100%;
}
</style>